import "./App.css";
// import Main from "./components/Main";
import Calculator from "./components/Calculator"
function App() {

  return (

<div> 
  <h1 className="name-project">Calculator 9000</h1>
  {/* <Main></Main> */}
  <Calculator />
</div>

  );
}

export default App;